export const TipoMoneda = [
  {
    name: '',
    value: 0
  },
  {
    name: 'CLP',
    value: 1
  },
  {
    name: 'USD',
    value: 2
  }
]